import { caseNotesApi } from "@/api";
import { HANDLE_ERROR_LOCALLY_HEADER } from "@/api/middleware/errorMiddleware";

/**
 * Fetches the letterheaded PDF for a text-based case note. Errors are handled by the caller (its own
 * "printing failed" message), so the global error toast is suppressed.
 */
export async function fetchCaseNotePrintPdfBlob(clientId: string, noteId: string): Promise<Blob> {
  const response = await caseNotesApi.getCaseNotePrintDocumentRaw(
    { clientId, noteId },
    { headers: { [HANDLE_ERROR_LOCALLY_HEADER]: "true" } }
  );
  return response.raw.blob();
}
